import { toast } from "react-toastify";
import { apiSlice } from ".";

const vendorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVendors: builder.query({
      query: (agencyid) => `/Vendors/GetVendor?agencyid=${agencyid}`,
    }),
    postVendor: builder.mutation({
      query: (data) => ({
        url: "/Vendors/PostVendor",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Saving vendor...",
          success: "Vendor saved successfully ",
          error: "Error saving vendor ",
        });
      },
    }),
    putVendor: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/Vendors/PutVendor/${id}`,
        method: "POST", 
        body: { id, ...data }, 
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Updating vendor...",
          success: "Vendor updated successfully ",
          error: "Error updating vendor ",
        });
      },
    }),
    deleteVendor: builder.mutation({
      query: (id) => ({
        url: `/Vendors/DeleteVendor/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Deleting vendor...",
          success: "Vendor deleted successfully ",
          error: "Error deleting vendor ",
        });
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetVendorsQuery,
  usePostVendorMutation,
  usePutVendorMutation,
  useDeleteVendorMutation,
} = vendorApi;
